import { render } from "./Calendario.vue?vue&type=template&id=cd333e3c&scoped=true"
const script = {}

import "./Calendario.vue?vue&type=style&index=0&id=cd333e3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cd333e3c"

export default script